import React from 'react';
import './App.css';
import Weather from "./Weather"

function App() {
  return (
    <div className="App">
          <Weather defaultCity="Sydney"/>
        </div>
  );
}
export default App;
